import { ajvResolver } from '@hookform/resolvers/ajv'
import { useAuth } from 'contexts/auth'
import { useAuthentications } from 'contexts/authentications'
import { useCallback, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory, useParams } from 'react-router-dom'
import LetterOfAttorneyEsocialSchema, {
  ILetterOfAttorneyEsocialFormData,
} from 'schema/authentication/letter-of-attorney-esocial'
import api from 'services/api'

interface IRouteParams {
  token: string
}

const useComponent = () => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  const [isDisabled, setIsDisabled] = useState<boolean>(true)
  const [mainError, setMainError] = useState('')

  const { user, updateUserData } = useAuth()
  const { refetchValidate } = useAuthentications()

  const params = useParams<IRouteParams>()
  const history = useHistory()

  const { register } = useForm<ILetterOfAttorneyEsocialFormData>({
    resolver: ajvResolver(LetterOfAttorneyEsocialSchema),
  })

  const onSubmit = useCallback(async () => {
    setIsSubmitting(true)
    try {
      const payLoad = {
        cnpj: user && user.organization?.cnpj,
      }

      await api.patch('/users/letter-of-attorney', payLoad)

      await updateUserData()
      setIsSubmitting(false)
      refetchValidate()
      return history.push('/connected-certificate')
    } catch (err) {
      setIsSubmitting(false)
      setMainError('Ops! Algum erro aconteceu!')
    }
  }, [history, params, isSubmitting, updateUserData, user, refetchValidate])

  const handleChange = (formField: any) => {
    setMainError('')
  }

  const handleBack = () => {
    history.push('/esocial-connect')
  }

  const handleClick = (content: string) => {
    navigator.clipboard.writeText(content)
  }

  const handleNavigateToECAC = () => {
    window.open('https://cav.receita.fazenda.gov.br/', '_blank')
  }

  return {
    isSubmitting,
    isDisabled,
    register,
    onSubmit,
    setIsDisabled,
    handleBack,
    handleClick,
    handleChange,
    handleNavigateToECAC,
  }
}

export default useComponent
